import Handsontable from 'handsontable'
import { createRoot } from 'react-dom/client'
import { SelectTreeDropdown } from '@components/formFields/selectTreeDropdown'
import * as ListDataManager from 'dataContainer/listDataManager'
import { ReactTreeSelect } from './components/tree-select'

let isFeatureChipsUIListsEnabled = false
export class TreeSelectEditor extends Handsontable.editors.TextEditor {
  constructor(props) {
    super(props)
    this.listenerFunction = function (ev) {
      const prevent = function () {
        ev.stopPropagation()
        ev.preventDefault()
        ev.returnValue = false
        return false
      }
      return prevent()
    }

    this.localdata = []
  }

  prepare() {
    super.prepare(...arguments)
  }

  open() {
    this.hot.unlisten()

    // this.TEXTAREA_PARENT.appendChild(this.popover);

    this.parent = document.getElementById('reactTree')

    if (!this.parent) {
      this.TEXTAREA_REACT = document.createElement('div')
      this.TEXTAREA_REACT.setAttribute('id', 'reactTree')
      this.TEXTAREA_PARENT.appendChild(this.TEXTAREA_REACT)
      this.TEXTAREA_PARENT.className = `${this.TEXTAREA_PARENT.className} react`
      this.parent = this.TEXTAREA_REACT
    }

    this.onBeforeKeyDown = function (event) {
      // this shouldn't work. The error in javascript makes this work though. Wierd AF.
      switch (event.keyCode) {
        case Handsontable.helper.keyCode?.ARROW_UP:
          event.stopImmediatePropagation() // prevent EditorManager from processing this event
          event.preventDefault() // prevent browser from scrolling the page up
          break

        case Handsontable.helper.keyCode?.ARROW_DOWN:
          event.stopImmediatePropagation() // prevent EditorManager from processing this event
          event.preventDefault() // prevent browser from scrolling the page up
          break

        default:
          break
      }
    }

    this.instance.addHook('beforeKeyDown', this.onBeforeKeyDown)

    const self = this
    this.handleClose = function () {
      self.finishEditing()
      self.close()
      self.TD?.focus()
      // self.instance.deselectCell();
      self.instance.selectCell(self.row, self.col)
    }

    this.updateData = function (data) {
      self.localdata = data
    }

    const selected = null

    this.textareaStyle = this.TEXTAREA.style
    this.textareaStyle.width = 0
    this.textareaStyle.height = 0
    this.textareaStyle.minWidth = 0
    this.textareaStyle.maxWidth = 0

    this.textareaReactStyle = this.TEXTAREA_REACT.style
    this.textareaReactStyle.top = 2
    this.textareaReactStyle.position = 'absolute'
    this.textareaReactStyle.width = '100%'
    this.textareaReactStyle.height = 350

    this.TEXTAREA_PARENT.style.width = `${this.TD.getClientRects()[0]?.width}px`

    // lookup the nested options for the list directly from the ListDataManager
    const templateField = this.cellProperties
    const governanceOwner =
      templateField.field.segment_type === 'variable' ? templateField : templateField.field
    const listId =
      governanceOwner && governanceOwner.list_governance && governanceOwner.list_governance.list_id
    const data = JSON.parse(JSON.stringify(ListDataManager.getListNestedValues(listId)))
    const selectedValues = this.originalValue
      ? this.originalValue.split(this.cellProperties.divider)
      : []
    const selectedNodes = []

    selectedValues.forEach(sv => {
      const treeValues = sv.split(this.cellProperties.indicator)
      treeValues.reduce((memo, val, index, array) => {
        const subSelect = memo.find(search => search.value === val)
        if (!subSelect) {
          return []
        }
        if (index === array.length - 1) {
          subSelect.checked = true
          selectedNodes.push(subSelect)
          return subSelect
        }
        return subSelect.children
      }, data)
      // traverse the tree and mark the values as selected within the data
    })

    this.localdata = selectedNodes

    const multi = !!governanceOwner.list_governance.multi

    if (!this.root) {
      this.root = createRoot(this.parent)
    }

    if (isFeatureChipsUIListsEnabled) {
      this.root.render(
        <SelectTreeDropdown
          data={data}
          updateData={this.updateData}
          selected={selected}
          row={this.row}
          close={this.handleClose}
          multi={multi}
          parent={this.TD}
          showDropdown="always"
        />,
      )
    } else {
      this.root.render(
        <ReactTreeSelect
          data={data}
          updateData={this.updateData}
          selected={selected}
          row={this.row}
          close={this.handleClose}
          multi={multi}
          parent={this.TD}
        />,
      )
    }
    document
      .querySelectorAll('#reactTree')[0]
      .addEventListener('wheel', this.listenerFunction, { passive: true })
    // document.querySelectorAll('.scrollBlocker')[0].classList.add('show')

    this.refreshDimensions() // need it instantly, to prevent https://github.com/handsontable/handsontable/issues/348
    this.showEditableElement()
    super.open()
  }

  getValue() {
    const val =
      this.localdata && this.localdata
        ? this.localdata
            .map(item => {
              const index = item.row.indexOf(item.value)
              return item.row.slice(0, index + 1).join(this.cellProperties.indicator)
            })
            .sort()
            .join(this.cellProperties.divider)
        : ''
    return val
  }

  setValue(value) {
    this.TEXTAREA.value = value
  }

  focus() {
    // don't
  }

  finishEditing(restoreOriginalValue, ctrlDown, callback) {
    // document.querySelectorAll('.scrollBlocker')[0].classList.remove('show')
    document.querySelectorAll('#reactTree')[0]?.removeEventListener('wheel', this.listenerFunction)
    super.finishEditing(restoreOriginalValue, ctrlDown, callback)

    if (this.root) {
      this.root.unmount()
      this.root = null
    }
    if (this.parent && this.parent.parentNode) {
      this.parent.parentNode.removeChild(this.parent)
      this.parent = null
    }
  }

  close(...args) {
    this.localdata = []
    this.instance.removeHook('beforeKeyDown', this.onBeforeKeyDown)
    if (!this.instance.rootElement) {
      return
    }
    this.state = 'STATE_FINISHED'

    super.close(...args)
  }

  createElements() {
    super.createElements()
    this.TEXTAREA_REACT = document.createElement('div')
    this.TEXTAREA_REACT.setAttribute('id', 'reactTree')
    this.TEXTAREA_PARENT.appendChild(this.TEXTAREA_REACT)
    this.TEXTAREA_PARENT.className = `${this.TEXTAREA_PARENT.className} react`
  }

  static setFeatureChipsUILists(featureChipsUILists) {
    isFeatureChipsUIListsEnabled = featureChipsUILists
  }
}
